/**
 * Sentry Ignore Errors Configuration
 *
 * This file contains patterns for errors that should be ignored by Sentry.
 * These are typically third-party script errors, user cancellations, or known edge cases
 * that don't require tracking.
 */

/**
 * Common error patterns to ignore across all platforms (webapp, mobile)
 */
export const COMMON_IGNORE_ERRORS = [
  // ============================================
  // Google Analytics (gtag) Related Errors
  // ============================================
  'gtag is not defined',
  "Can't find variable: gtag",
  /b\.match is not a function.*b\.match\(\/\^\(gtm\|gtag\)\\/,

  // ============================================
  // UXA Analytics Related Errors
  // ============================================
  /undefined is not an object \(evaluating 'window\._uxa\.getDecision'\)/,
  /Cannot read properties? of undefined \(reading '_uxa'\)/,
  /window\._uxa is undefined/,

  // ============================================
  // OneTrust / CookieLaw Related Errors
  // ============================================
  /Event XMLHttpRequestProgressEvent.*Cancelled.*cdn\.cookielaw\.org/,
  /Failed to load.*cdn\.cookielaw\.org/,
  /Error loading.*cookielaw\.org/,
  /cdn\.cookielaw\.org.*OtAutoBlock\.js/,
  /cdn\.cookielaw\.org.*otSDKStub\.js/,

  // ============================================
  // Facebook Pixel Related Errors
  // ============================================
  /Conversion API events sent via Browser API are not attributed to a pixel/,
  /JavaScript SDK detects and collects a drop in event volume/,
  /fbq is not defined/,
  /Cannot read properties? of undefined \(reading 'fbq'\)/,

  // ============================================
  // Network / Request Cancellation Errors
  // Note: Generic network errors are handled in beforeSend
  // to filter by domain (only ignore 3rd-party, not our own API/CDN)
  // ============================================

  // ============================================
  // Stripe Payment – Test Card Errors
  // ============================================
  /used a known test card/i,

  // ============================================
  // Generic Third-Party Script Errors
  // ============================================
  /Script error\./,
  /ResizeObserver loop/,
];

/**
 * Webapp-specific error patterns to ignore
 */
export const WEBAPP_IGNORE_ERRORS = [
  ...COMMON_IGNORE_ERRORS,
  // Add webapp-specific patterns here if needed
];

/**
 * Mobile-specific error patterns to ignore
 */
export const MOBILE_IGNORE_ERRORS = [
  ...COMMON_IGNORE_ERRORS,
  // Add mobile-specific patterns here if needed
];
